import { InformePendiente } from "./InformePendiente";

export interface InformesInvestigador {
    pendiente: boolean,
    informes: Array<InformePendiente>
}

export function InitialInformesInvestigador(): InformesInvestigador {
    return {
        pendiente: false,
        informes: []
    }
}